import styled from 'styled-components';

export const DropdownWrap = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 1.25rem 1.25rem 0 1.25rem;
`;
